export default __webpack_public_path__ + "static/media/company-logo.19181a3c.png";